import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimTypes } from 'src/app/model/claim-type.model';

@Component({
    selector: 'app-third-party-liability-claim',
    templateUrl: './third-party-liability-claim.component.html',
    styleUrls: ['./third-party-liability-claim.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ThirdPartyLiabilityClaimComponent implements OnInit {

  constructor( private transactionInfoService: TransactionInfoService) {
      this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_HOME_TP_LIABILITY]);
  }

  ngOnInit() {
  }

}


